import { render, staticRenderFns } from "./guoqiSoe.vue?vue&type=template&id=4492a1ee&scoped=true"
import script from "./guoqiSoe.vue?vue&type=script&lang=js"
export * from "./guoqiSoe.vue?vue&type=script&lang=js"
import style0 from "./guoqiSoe.vue?vue&type=style&index=0&id=4492a1ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4492a1ee",
  null
  
)

export default component.exports